export default "__VITE_ASSET__aae2047a__"